/* eslint-disable max-len */
import { CompanyAPI } from '@api';

const acceptInstallmentAnticipation = async (id, checkboxes) => {
  const params = {
    lending_id: id,
    accepted: true,
    checkboxes,
  };

  return CompanyAPI.acceptOrRejectInstallmentAnticipation(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { acceptInstallmentAnticipation };
